var _a, _b;
// 运单状态
export var WAYBILL_STATUS = {
    /** 待寄出 */
    TO_SENT: '0',
    /** 运送中 */
    TRANSPORTING: '2',
    /** 派送中 */
    DELIVERING: '3',
    /** 已签收 */
    RECEIVED: '4',
    /** 已作废 */
    ABOLISHED: '5',
    /** 已取消 */
    CANCELLED: '6',
    /** 已退回 */
    FORWARDED: '8',
    /** 已转寄 */
    RETURNED: '9',
    /** 已取件 */
    PICKED: '10',
    /** 待取件 */
    WAITING_FOR_PICK: '11',
    /** 异常 */
    ABNORMAL: '12',
    /** 待派送 */
    WAITING_FOR_DELIVERY: '13'
};
// 运单状态对应中文
export var WAYBILL_STATUS_TEXT_MAP = (_a = {},
    _a[WAYBILL_STATUS.TO_SENT] = '待寄出',
    _a[WAYBILL_STATUS.TRANSPORTING] = '运送中',
    _a[WAYBILL_STATUS.DELIVERING] = '派送中',
    _a[WAYBILL_STATUS.RECEIVED] = '已签收',
    _a[WAYBILL_STATUS.ABOLISHED] = '已作废',
    _a[WAYBILL_STATUS.CANCELLED] = '已取消',
    _a[WAYBILL_STATUS.FORWARDED] = '已退回',
    _a[WAYBILL_STATUS.RETURNED] = '已转寄',
    _a[WAYBILL_STATUS.PICKED] = '已取件',
    _a[WAYBILL_STATUS.WAITING_FOR_PICK] = '待取件',
    _a[WAYBILL_STATUS.ABNORMAL] = '异常',
    _a[WAYBILL_STATUS.WAITING_FOR_DELIVERY] = '待派送',
    _a);
/**
 * 订单状态
 */
export var APPOINTMENT_STATUE = {
    ACCEPTING: '0',
    ACCEPTED: '1',
    ORDER_FAILED: '2',
    ORDER_NOTIFIED: '3',
    PICKED: '5',
    PICKED_ERROR: '6',
    CANCELLED: '7',
    PLD_STORAGE: '8',
    IN_CABINET: '9',
    PICKED_ERR: '10',
    CLOSED: '12',
    COLLECTED: '13',
    WAIT_ORDER: '14',
    /**
     * 同城状态
     */
    CITY_TO_COLLECT: '40038',
    CITY_TO_PAY: '40039',
    CITY_TO_REFUND: '40040',
    CITY_REFUNDED: '40041',
    CITY_CANCELLED: '40042',
    CITY_DELIVERING: '40043',
    CITY_COMPLETED: '40044',
    CITY_REJECTED: '40049',
    CITY_TO_ORDER: '40050',
    CITY_CHANGE: '40061' // 大网单转同城单
};
// 寄件类型
export var PICK_UP_TYPE = {
    SERVICE_POINT_SELF: '0',
    VISIT_PICK_UP: '1',
    IVR: '2',
    SCAN_CODE: '3',
    SF_CABINET_SELF: '4',
    CCS5: '5',
    SHUN_XIN_BAO: '6',
    QR_CODE: '7',
    APP: '8',
    YOUNGOR_IN_STORE: '9',
    HANGZHOU_CITYWIDE: '10',
    CHANNEL: '12',
    CUSTOMER_SERVICE_SYSTEM_ASR: '16',
    SHUN_XIN_JI: '17',
    BEIJING_CITYWIDE: '18',
    CUSTOMER_SERVICE_SYSTEM_H5: '19',
    SCAN_ME: '20',
    EXCLUSIVE_COURIER: '23',
    ONE_KEY_OUTBOUND_CALL: '24',
    SELF_SEND_TO_ORDER: '25',
    STORE_SEND_TO_ORDER: '26',
    GIFTS: '27',
    SCAN_RESERVE: '28' // 扫码预约
};
// 巴枪操作码
export var HHT_CODE = {
    SEND: '50',
    RECEIVE: '80',
    INTO_WAREHOUSE: '43',
    OUT_WAREHOUSE: '44',
    LOAD_VEHICLE: '30',
    UNLOAD_VEHICLE: '31' // 卸车 |  中转环节 |
};
// 寄件类型名称
export var EXPRESS_TYPE = {
    /* 批量寄 */
    BATCH: 'batch',
    /* 批量礼物寄 */
    BATCH_GIFTS: 'batch-gifts',
    /* 寄快递-上门取件 */
    NORMAL: 'normal',
    /* 寄快递-丰巢寄件 */
    FCBOX_New: 'fcbox-new',
    /* 丰巢寄件 */
    FCBOX: 'fcbox',
    /* 服务点自寄 */
    SERVICE: 'service',
    /* 服务点自寄-合作商家店 */
    SHOP: 'shop',
    /* 防疫物资 */
    ASSISTANCE: 'assistance',
    /* 寄大件 */
    LARGE: 'large',
    /* 扫码寄件 */
    SCAN: 'scan',
    /* 扫我寄件 */
    SCANME: 'scanme',
    /* 专属快递员 */
    EXCLUSIVE: 'exclusive',
    /* 国际/港澳台 */
    INTERNATIONAL: 'international',
    /* 智能寄件 */
    PSDS: 'psds',
    /* 生鲜寄 */
    FRESH: 'fresh',
    /* 国际/港澳台 OSMS */
    INTERNATIONAL_OSMS: 'international-osms',
    /* 委托件 */
    DELEGATE: 'delegate-express',
    /* 礼物寄 */
    GIFTS: 'gifts',
    /* 扫码转预约 */
    SCAN_NORMAL: 'scan-normal'
};
// 同城运单状态码
export var INTRA_CITY_WAYBILL_STATE = {
    PAYING: 'PAYING',
    INIT: 'INIT',
    WAIT_HAND_OVER: 'WAIT_HAND_OVER',
    DELIVERING: 'DELIVERING',
    FINISHED: 'FINISHED',
    CANCELED: 'CANCELED',
    REFUNDING: 'REFUNDING',
    WAIT_REFUND: 'WAIT_REFUND',
    REFUNDED: 'REFUNDED',
    ABNORMAL: 'ABNORMAL' // 订单异常
};
// 同城运单状态码描述 map
export var INTRA_CITY_WAYBILL_STATE_MAP = (_b = {},
    _b[INTRA_CITY_WAYBILL_STATE.PAYING] = '待支付',
    _b[INTRA_CITY_WAYBILL_STATE.INIT] = '订单未/已分配小哥',
    _b[INTRA_CITY_WAYBILL_STATE.WAIT_HAND_OVER] = '待上门',
    _b[INTRA_CITY_WAYBILL_STATE.DELIVERING] = '运送中',
    _b[INTRA_CITY_WAYBILL_STATE.FINISHED] = '已签收',
    _b[INTRA_CITY_WAYBILL_STATE.CANCELED] = '已取消',
    _b[INTRA_CITY_WAYBILL_STATE.REFUNDING] = '退款中',
    _b[INTRA_CITY_WAYBILL_STATE.WAIT_REFUND] = '待确认退款',
    _b[INTRA_CITY_WAYBILL_STATE.REFUNDED] = '已退款',
    _b[INTRA_CITY_WAYBILL_STATE.ABNORMAL] = '订单异常',
    _b);
// 申报物收寄件身份 证件类型
export var IDENTITY_CODE_TYPE = {
    /** 生日/个人清关代码 */
    BIRTHDAY_OR_PERSONAL: '016',
    /** 企业清关代码 */
    COMPANY_CODE: '017',
    /** 公司营业执照号 */
    BUSINESS_LICENSE: '018',
    /** 身份证 */
    IDENTITY_CARD: '001',
    /** 统编号 */
    TW_IDENTITY_CODE: '009',
    /** 居留证 */
    RESIDENCE_CERT: '023',
    /** 护照 */
    PASSPORT: '002'
};
/** 未完成订单状态 */
export var INCOMPLETE_ORDER_STATUS = {
    /** 系统故障 */
    ERROR: 0,
    /** 创建 初始状态 */
    CREATE: 1,
    /** 已失效 */
    INVALID: 2,
    /** 主动取消 */
    ACTIVE_CANCEL: 3,
    /** 系统自动取消 */
    AUTO_CANCEL: 4,
    /** 下单成功 */
    ORDER_SUCCESS: 5,
    /** 下单失败 */
    ORDER_FAIL: 6,
    /** 删除 */
    DELETE: 7,
    /** 已推送 */
    PUSH: 8
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/business-constants/dist/esm/order.js
// module id = null
// module chunks = 